import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook.icon-169854",
  "use": "facebook.icon-169854-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"facebook.icon-169854\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.0066 21.0002V13.4737H16.5078L16.8823 10.5405H14.0066V8.66772C14.0066 7.81848 14.24 7.23977 15.4458 7.23977L16.9837 7.23904V4.61557C16.7175 4.57989 15.8048 4.5 14.7428 4.5C12.5256 4.5 11.0076 5.86693 11.0076 8.37731V10.5405H8.5V13.4737H11.0076V21.0002H14.0066Z\" fill=\"var(--svg-primary-color)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol